export default __webpack_public_path__ + "static/media/doc.2efc607a.svg";